module.exports = __webpack_public_path__ + "static/media/post_purchase.3766f66b.png";